import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//

import { openMap } from '@/utils';
import Drip from 'drip';
export default {
  props: {
    shopName: String,
    cityName: String,
    shopId: String,
    address: String,
    lat: Number,
    lng: Number,
    isLive: Boolean,
    performanceId: Number
  },
  data: function data() {
    return {
      isFromMtwxapp: Drip.UA.IS_WXAPP_MEITUAN
    };
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_b_q9p6kdod_mv',
      cid: 'c_c21utqjf',
      abtest: 1,
      custom: {
        performance_id: this.performanceId
      }
    });
  },
  methods: {
    click: function click() {
      if (this.isFromMtwxapp) {
        // 美团小程序无法跳转到腾讯的域名，如果要支持的话，需要联系美团小程序给腾讯的域名加白名单
        return;
      }
      window.lxTagReport('c_c21utqjf', 'b_q9p6kdod', {
        performance_id: this.performanceId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_q9p6kdod',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.performanceId
        }
      });
      if (this.isLive) return;
      if (location.href.includes('fromSearch=true')) {
        return;
      }
      var shopId = this.shopId,
        lat = this.lat,
        lng = this.lng,
        address = this.address,
        shopName = this.shopName;
      openMap({
        shopId: shopId,
        lat: lat,
        lng: lng,
        address: address,
        shopName: shopName
      });
    }
  }
};